import {getUserUnlocksCompletedKeys} from '../b5-unlocks/getUserUnlocks'

export function getSeenUnlocksFromLocalstorage() {
  const seenUnlocks = window.localStorage.getItem("seenUnlocks");
  if (seenUnlocks) {
    return seenUnlocks.split(','); //formatted as userUnlocksString below -> turn it back into an array
  }
  return [];
}

export function setSeenUnlocksInLocalstorage() {
  const userUnlocksString = getUserUnlocksCompletedKeys().join(',');
  window.localStorage.setItem("seenUnlocks", userUnlocksString);
}


// WEBPACK FOOTER //
// ./src/b5-home/unlock-localstorage-operations.js